import Filter from "./filter";
import { Currencies } from "../utils/currencies";
import { request } from "@/store";
import moment from "moment";
import { FLOATING_COMPOUND_TABLE_STATES, GROUP_BY_TAB_ELEMENTS, APP_PERIOD_DROPDOWN_ELEMENTS, APP_LTV_DROPDOWN_ELEMENTS, APP_LTV_OFFSET_DROPDOWN_ELEMENTS } from "@/utils/constants";
import { PERIOD_OPTIONS, PERIOD_OPTIONS_V2 } from "../utils/constants";
import { DATE_PICKER_RANGE_TITLES, getHistoryPeriodSelector } from "../utils/datepicker";
import { computeCurrencyMaxCharCount, computeNumberMaxCharCount, computePercentageMaxCharCount, processChildrenToMap, computeCumulativeMap } from "@/utils/transformers";
import { computeMinMax, transformWithCountries } from "@/utils";
const DEFAULT_EMPTY_ROW_SIZE = 20;
const customer_insights = {
  state: {
    sellers_filter: new Filter([], []),
    marketplaces_filter: new Filter([], [], "marketplace_id"),
    currencies: new Filter(Currencies, [], "symbol"),
    total_rows: null,
    page_limit: 20,
    page_offset: 1,
    currentTab: 0,
    keyword_list: [],
    currentTabValue: "dashboard",
    tabs: [{
      text: "Dashboard",
      value: "dashboard",
      activeBg: "#F3EEFF",
      activeColor: "#423994",
      feature: "default",
      event: "customerInsightsDashboardTabOpened"
    }],
    metricOptions: [{
      text: "Revenue metric",
      value: "revenue",
      event: "customerInsightsRevenueMetric"
    }, {
      text: "Margin metric",
      value: "margin",
      event: "customerInsightsMarginMetric"
    }],
    currentMetricValue: "revenue",
    selected_granularity: APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY.endOf.toUpperCase(),
    period: APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY.value,
    periodSelectorOptions: [APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY, APP_PERIOD_DROPDOWN_ELEMENTS.QUARTERLY],
    periodCategory: PERIOD_OPTIONS_V2[APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY.value].LEFT.queryKey,
    periodOptions: [PERIOD_OPTIONS.PREV_PERIOD, PERIOD_OPTIONS.SAME_PERIOD_LY],
    ltv: APP_LTV_DROPDOWN_ELEMENTS.LTV.value,
    ltvSelectorOptions: [APP_LTV_DROPDOWN_ELEMENTS.LTV, APP_LTV_DROPDOWN_ELEMENTS.REPEAT_LTV, APP_LTV_DROPDOWN_ELEMENTS.REPEAT_AOV, APP_LTV_DROPDOWN_ELEMENTS.REPURCHASE_RATE, APP_LTV_DROPDOWN_ELEMENTS.REPURCHASE_FREQUENCY],
    ltvOffset: [APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_0.value, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_3.value, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_6.value, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_12.value],
    ltvOffsetOptions: [APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_0, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_1, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_2, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_3, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_4, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_5, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_6, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_7, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_8, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_9, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_10, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_11, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_12, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_13, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_14, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_15, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_16, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_17, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_18, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_19, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_20, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_21, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_22, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_23, APP_LTV_OFFSET_DROPDOWN_ELEMENTS.LTV_OFFSET_24],
    currentPeriod: {
      [APP_PERIOD_DROPDOWN_ELEMENTS.MONTHLY.value]: {
        title: {
          prev_period: "Current month vs previous month",
          same_period_ly: "Current month vs same period last year"
        },
        format: "MMM YYYY",
        date: moment().startOf("month"),
        groupBy: DATE_PICKER_RANGE_TITLES.CURRENT_MONTH,
        groupByCompare: {
          title: "Preceding Period",
          subtitle: "(match to date)"
        }
      },
      [APP_PERIOD_DROPDOWN_ELEMENTS.QUARTERLY.value]: {
        title: {
          prev_period: "Current quarter vs previous quarter",
          same_period_ly: "Current quarter vs same period last year"
        },
        format: "MMM YYYY",
        date: moment().startOf("quarter"),
        groupBy: DATE_PICKER_RANGE_TITLES.CURRENT_QUARTER,
        groupByCompare: {
          title: "Preceding Period",
          subtitle: "(match to date)"
        }
      },
      [APP_PERIOD_DROPDOWN_ELEMENTS.YEARLY.value]: {
        title: {
          prev_period: "vs previous year",
          same_period_ly: "vs same year two years ago"
        },
        format: "MMM D, YYYY",
        date: moment().startOf("year"),
        groupBy: DATE_PICKER_RANGE_TITLES.LAST_WEEK,
        groupByCompare: {
          title: "Preceding Period",
          subtitle: "(match to date)"
        }
      }
    },
    periodTable: {
      dashboard: {
        items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
        maxCharCount: {},
        minMax: {}
      },
      ltv: {
        items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
        maxCharCount: {},
        minMax: {}
      },
      ltv_per_asin: {
        items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
        maxCharCount: {},
        minMax: {}
      },
      period_page: 1
    },
    currencyConfig: {
      full: false,
      currency: "EUR",
      precision: 0,
      showCurrencySign: true,
      digitSeparator: ".",
      limit: 10_000
    },
    product_table: {
      state: FLOATING_COMPOUND_TABLE_STATES.INTERMEDIATE,
      group_by: 0,
      group_by_text: "",
      group_by_elements: [],
      competitor_parents: new Map(),
      dashboard: {
        period: null,
        data: {
          seller: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {},
            fetch: "customerInsightsFetchReportGroupedSellers"
          },
          marketplace: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {},
            fetch: "customerInsightsFetchReportGroupedMarketplaces"
          }
        }
      },
      ltv: {
        period: null,
        data: {
          seller: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {},
            fetch: "customerInsightsFetchReportGroupedSellers"
          },
          marketplace: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {},
            fetch: "customerInsightsFetchReportGroupedMarketplaces"
          }
        }
      },
      ltv_per_asin: {
        period: null,
        data: {
          seller: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {},
            fetch: "customerInsightsFetchReportGroupedSellers"
          },
          marketplace: {
            items: new Array(DEFAULT_EMPTY_ROW_SIZE).fill({}),
            total: [],
            minMax: {},
            maxCharCount: {},
            page: 1,
            perPage: 20,
            totalPages: 0,
            sort: {},
            fetch: "customerInsightsFetchReportGroupedMarketplaces"
          }
        }
      }
    },
    url: {
      dashboard: "/customer_insights/evolution",
      ltv: "/customer_insights/ltv",
      ltv_per_asin: "/customer_insights/ltvperasin"
    }
  },
  mutations: {
    customerInsightsTotalRowsSet(state, payload) {
      state.total_rows = payload;
    },
    customerInsightsPageLimitSet(state, payload) {
      state.page_limit = payload;
    },
    customerInsightsPageOffsetSet(state, payload) {
      state.page_offset = payload;
    },
    customerInsightsSellersFilterSet(state, payload) {
      state.sellers_filter.restore(payload);
    },
    customerInsightsMarketplacesFilterSet(state, payload) {
      state.marketplaces_filter.restore(payload);
    },
    customerInsightsDefaultCurrencySet(state, payload) {
      // We need to update the currency filter
      state.currencies.selectOnly({
        symbol: payload
      }, "symbol");
      state.currencies.apply();
    },
    customerInsightsSetCurrentTab(state, payload) {
      const {
        tabIndex,
        tabValue
      } = payload;
      state.currentTab = tabIndex;
      state.currentTabValue = tabValue;
    },
    customerInsightsSetCurrentMetricValue(state, payload) {
      state.currentMetricValue = payload;
    },
    customerInsightsSetPeriod(state, payload) {
      state.period = payload;
    },
    customerInsightsSetGranularity(state, payload) {
      state.selected_granularity = payload;
    },
    customerInsightsSetLTV(state, payload) {
      state.ltv = payload;
    },
    customerInsightsSetLTVOffset(state, payload) {
      state.ltvOffset = payload.sort((a, b) => {
        const getNum = str => Number(str.split("_").pop());
        return getNum(a) - getNum(b);
      });
    },
    customerInsightsSetPeriodCategory(state, payload) {
      state.periodCategory = payload;
    },
    customerInsightsSetPeriodTableItems(state, payload) {
      state.periodTable["dashboard"].items = payload;
      state.periodTable["ltv"].items = payload;
      state.periodTable["ltv_per_asin"].items = payload;
    },
    customerInsightsSetPeriodTableMinMax(state, payload) {
      state.periodTable["dashboard"].minMax = payload;
      state.periodTable["ltv"].minMax = payload;
      state.periodTable["ltv_per_asin"].minMax = payload;
    },
    customerInsightsSetPeriodTableMaxCharCount(state, payload) {
      state.periodTable["dashboard"].maxCharCount = payload;
      state.periodTable["ltv"].maxCharCount = payload;
      state.periodTable["ltv_per_asin"].maxCharCount = payload;
    },
    customerInsightsSetProductTableMinMax(state, payload) {
      state.product_table["dashboard"].data[state.product_table.group_by_text].minMax = payload;
      state.product_table["ltv"].data[state.product_table.group_by_text].minMax = payload;
      state.product_table["ltv_per_asin"].data[state.product_table.group_by_text].minMax = payload;
    },
    customerInsightsSetProductTableTotal(state, payload) {
      state.product_table["dashboard"].data[state.product_table.group_by_text].total = payload;
      state.product_table["ltv"].data[state.product_table.group_by_text].total = payload;
      state.product_table["ltv_per_asin"].data[state.product_table.group_by_text].total = payload;
    },
    customerInsightsSetProductTableTotalPages(state, payload) {
      state.product_table["dashboard"].data[state.product_table.group_by_text].totalPages = payload;
      state.product_table["ltv"].data[state.product_table.group_by_text].totalPages = payload;
      state.product_table["ltv_per_asin"].data[state.product_table.group_by_text].totalPages = payload;
    },
    customerInsightsSetProductTableItems(state, payload) {
      state.product_table["dashboard"].data[state.product_table.group_by_text].items = payload;
      state.product_table["ltv"].data[state.product_table.group_by_text].items = payload;
      state.product_table["ltv_per_asin"].data[state.product_table.group_by_text].items = payload;
    },
    customerInsightsSetProductTableMaxCharCount(state, payload) {
      state.product_table["dashboard"].data[state.product_table.group_by_text].maxCharCount = payload;
      state.product_table["ltv"].data[state.product_table.group_by_text].maxCharCount = payload;
      state.product_table["ltv_per_asin"].data[state.product_table.group_by_text].maxCharCount = payload;
    },
    customerInsightsSetProductTablePeriod(state, payload) {
      state.product_table["dashboard"].period = payload;
      state.product_table["ltv"].period = payload;
      state.product_table["ltv_per_asin"].period = payload;
    },
    customerInsightsIncrementPeriodPage(state) {
      state.periodTable.period_page += 1;
    },
    customerInsightsSetProductTableSort(state, {
      sort,
      direction
    }) {
      state.product_table["dashboard"].data[state.product_table.group_by_text].sort = {
        [sort]: direction
      };
      state.product_table["ltv"].data[state.product_table.group_by_text].sort = {
        [sort]: direction
      };
      state.product_table["ltv_per_asin"].data[state.product_table.group_by_text].sort = {
        [sort]: direction
      };
    },
    customerInsightsSetProductTableGroupBy(state, payload) {
      state.product_table.group_by = payload;
      state.product_table.group_by_text = state.product_table.group_by_elements[payload].key;
    },
    customerInsightsKeyWordListSet(state, payload) {
      state.keyword_list = payload;
    }
  },
  getters: {
    customerInsightsGetFilters(state) {
      return () => {
        return {
          seller_id: state.sellers_filter.filterValues,
          sales_channel: state.marketplaces_filter.selectedValues.map(m => m.toLowerCase()),
          keyword_list: state.keyword_list
        };
      };
    },
    customerInsightsGetTab(state) {
      return () => state.currentTab;
    },
    customerInsightsGetTabValue(state) {
      return () => state.currentTab;
    },
    customerInsightsGetPeriod(state) {
      return () => state.period;
    },
    customerInsightsGetPeriodCategory(state) {
      return () => state.periodCategory;
    },
    customerInsightsGetLTV(state) {
      return () => state.ltv;
    },
    customerInsightsGetLTVOffset(state) {
      return () => state.ltvOffset;
    },
    customerInsightsGetPeriodOptions(state) {
      const currentPeriod = state.period;
      return [PERIOD_OPTIONS_V2[currentPeriod].LEFT, PERIOD_OPTIONS_V2[currentPeriod].RIGHT];
    },
    customerInsightsGetProductTablePager(state) {
      return () => ({
        page: state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.page,
        page_size: state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.perPage
      });
    },
    customerInsightsGetProductTableSort(state) {
      return () => {
        let obj = {
          sort_by: [],
          sort_direction: []
        };
        for (const [key, value] of Object.entries(state.product_table[state.currentTabValue].data?.[state.product_table.group_by_text]?.sort)) {
          obj["sort_by"].push(key);
          obj["sort_direction"].push(value);
        }
        return obj;
      };
    }
  },
  actions: {
    async customerInsightsFetchPeriodTableData({
      commit,
      getters,
      state
    }) {
      try {
        const params = {
          period: state.period,
          ...getters.customerInsightsGetFilters(),
          ...getters.currencyConfigQueryGet(),
          week_type: "monday",
          period_page: state.periodTable.period_page,
          selected_granularity: state.selected_granularity,
          page_limit: state.page_limit,
          page_offset: state.page_offset - 1
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request(state.url[state.currentTabValue], "POST", params);
        let data = response.data;
        if (data) {
          commit("customerInsightsSetPeriodTableItems", data);
          commit("customerInsightsSetPeriodTableMaxCharCount", {
            currency: computeCurrencyMaxCharCount(data, full, currency, precision, showCurrencySign, false, limit),
            number: computeNumberMaxCharCount(data),
            percentage: computePercentageMaxCharCount(data)
          });
          commit("customerInsightsSetPeriodTableMinMax", computeMinMax(data));
          let total_rows = response.total_rows[0].total_rows;
          commit("customerInsightsTotalRowsSet", total_rows);
        }
      } catch (err) {
        //console.log(err);
      }
    },
    customerInsightsSetDefaultCurrency({
      getters,
      commit
    }) {
      //console.log('getters', getters.currencyConfigQueryGet())
      commit("customerInsightsDefaultCurrencySet", getters.currencyConfigQueryGet().currency);
    },
    customerInsightsSetTab({
      commit
    }, tab) {
      commit("customerInsightsSetCurrentTab", tab);
    },
    customerInsightsSetMetric({
      commit
    }, value) {
      commit("customerInsightsSetCurrentMetricValue", value);
    },
    async customerInsightsFetchReportGroupedSellers({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.customerInsightsGetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.customerInsightsGetFilters(),
          ...getters.customerInsightsGetProductTableSort(),
          ...pager,
          ...getters.currencyConfigQueryGet()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/customer_insights/report/seller", "POST", params, false, true, "cors");
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          if (store) {
            commit("customerInsightsSetProductTableTotalPages", total?.[0]?.row_count ?? 0);
            commit("customerInsightsSetProductTableItems", report);
            commit("customerInsightsSetProductTableTotal", total?.pop() ?? {});
            commit("customerInsightsSetProductTableMaxCharCount", {
              currency: computeCurrencyMaxCharCount(report, full, currency, precision, showCurrencySign, false, limit),
              number: computeNumberMaxCharCount(report),
              percentage: computePercentageMaxCharCount(report)
            });
            commit("customerInsightsSetProductTableMinMax", computeMinMax(report));
          }
        }
        return response;
      } catch (err) {
        //console.log(err);
      }
    },
    async customerInsightsFetchReportGroupedMarketplaces({
      commit,
      getters,
      state
    }, options = {}) {
      try {
        let {
          pager,
          store = true
        } = options;
        if (!pager) {
          pager = getters.customerInsightsGetProductTablePager();
        }
        const params = {
          period: state.product_table[state.currentTabValue].period,
          ...getters.customerInsightsGetFilters(),
          ...getters.customerInsightsGetProductTableSort(),
          ...pager,
          ...getters.currencyConfigQueryGet()
        };
        const {
          full,
          currency,
          precision,
          showCurrencySign,
          limit
        } = getters.currencyConfigGet();
        let response = await request("/customer_insights/report/marketplace", "POST", params, false, true, "cors");
        if (response) {
          response = response.data;
          const {
            report,
            total
          } = response;
          if (store) {
            commit("customerInsightsSetProductTableTotalPages", total?.[0]?.row_count ?? 0);
            commit("customerInsightsSetProductTableItems", report);
            commit("customerInsightsSetProductTableTotal", total?.pop() ?? {});
            commit("customerInsightsSetProductTableMaxCharCount", {
              currency: computeCurrencyMaxCharCount(report, full, currency, precision, showCurrencySign, false, limit),
              number: computeNumberMaxCharCount(report),
              percentage: computePercentageMaxCharCount(report)
            });
            commit("customerInsightsSetProductTableMinMax", computeMinMax(report));
          }
        }
        return response;
      } catch (err) {
        //console.log(err);
      }
    },
    customerInsightsSetProductTablePeriod({
      commit
    }, period) {
      commit("customerInsightsSetProductTablePeriod", period);
    },
    customerInsightsSetPeriodCategory({
      commit
    }, period) {
      commit("customerInsightsSetPeriodCategory", period);
    },
    customerInsightsSetPeriod({
      commit
    }, period) {
      commit("customerInsightsSetPeriod", period);
    },
    customerInsightsSetGranularity({
      commit
    }, periodEndOf) {
      commit("customerInsightsSetGranularity", periodEndOf);
    },
    customerInsightsSetLTV({
      commit
    }, value) {
      commit("customerInsightsSetLTV", value);
    },
    customerInsightsSetLTVOffset({
      commit
    }, value) {
      commit("customerInsightsSetLTVOffset", value);
    },
    customerInsightsSetProductTableSort({
      commit
    }, payload) {
      commit("customerInsightsSetProductTableSort", payload);
    },
    customerInsightsSetProductTableGroupBy({
      commit
    }, groupBy) {
      commit("customerInsightsSetProductTableGroupBy", groupBy);
    },
    customerInsightsIncrementPeriodPage({
      commit
    }) {
      commit("customerInsightsIncrementPeriodPage");
    },
    customerInsightsKeyWordListSet({
      commit
    }, payload) {
      commit("customerInsightsKeyWordListSet", payload);
    },
    customerInsightsTotalRowsSet({
      commit
    }, payload) {
      commit("customerInsightsTotalRowsSet", payload);
    },
    customerInsightsPageLimitSet({
      commit
    }, payload) {
      commit("customerInsightsPageLimitSet", payload);
    },
    customerInsightsPageOffsetSet({
      commit
    }, payload) {
      commit("customerInsightsPageOffsetSet", payload);
    }
  }
};
export default customer_insights;